import DeleteIcon from '@mui/icons-material/Delete';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';

const deleteMessage = defineMessage({
  id: 'common.actions.delete',
  defaultMessage: 'Eliminar',
});

interface DeleteMenuItemProps {
  /** Called when the user requests delete (e.g. close menu and open confirm dialog). */
  readonly onAction: () => void;
  readonly disabled?: boolean;
}

/**
 * Overflow menu item that requests opening a delete confirmation dialog.
 */
export function DeleteMenuItem({ onAction, disabled = false }: DeleteMenuItemProps) {
  return (
    <MenuItem onClick={onAction} disabled={disabled} sx={{ color: 'error.main' }}>
      <ListItemIcon sx={{ color: 'inherit' }}>
        <DeleteIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>
        <FormattedMessage {...deleteMessage} />
      </ListItemText>
    </MenuItem>
  );
}
